import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, ArrowRight, XCircle, CheckCircle2 } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-24 bg-[#0a0a1a] relative overflow-hidden border-y border-white/5" data-id="element-315">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-red-900/10 rounded-full blur-[120px]" data-id="element-316" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-317">
        <div className="text-center mb-16" data-id="element-318">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-500/10 border border-red-500/20 text-red-400 text-sm font-medium mb-6" data-id="element-319">
            <AlertCircle className="w-4 h-4" data-id="element-320" />
            El problema de la mayoría de restaurantes
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-5xl font-bold font-orbitron mb-6" data-id="element-321">
            Muchos restaurantes publican en Instagram...{' '}
            <br className="hidden md:block" data-id="element-322" />
            <span className="text-red-400" data-id="element-323">pero las mesas siguen vacías.</span>
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center max-w-5xl mx-auto" data-id="element-324">
          {/* The Problem */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#050510] border border-red-500/20 rounded-3xl p-8 relative overflow-hidden" data-id="element-325">
            <div className="absolute top-0 left-0 w-2 h-full bg-red-500/50" data-id="element-326" />
            <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-327">
              <XCircle className="w-6 h-6 text-red-400" data-id="element-328" />
              Lo que pasa actualmente:
            </h3>
            <ul className="space-y-4" data-id="element-329">
              <li className="flex items-start gap-3 text-gray-400" data-id="element-330">
                <span className="text-red-400 mt-1" data-id="element-331">•</span>
                <span data-id="element-332">
                  Los clientes ven tu comida en redes, pero no saben cómo
                  reservar o pedir.
                </span>
              </li>
              <li className="flex items-start gap-3 text-gray-400" data-id="element-333">
                <span className="text-red-400 mt-1" data-id="element-334">•</span>
                <span data-id="element-335">
                  Te escriben preguntando "¿tienen disponibilidad?" y luego
                  desaparecen porque no ven tu menú completo ni ambiente.
                </span>
              </li>
              <li className="flex items-start gap-3 text-gray-400" data-id="element-336">
                <span className="text-red-400 mt-1" data-id="element-337">•</span>
                <span data-id="element-338">
                  Invertís en publicidad, conseguís seguidores, pero las mesas
                  siguen con espacios vacíos.
                </span>
              </li>
            </ul>
          </motion.div>

          {/* The Solution */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-gradient-to-br from-purple-900/20 to-pink-900/20 border border-purple-500/30 rounded-3xl p-8 relative overflow-hidden" data-id="element-339">
            <div className="absolute top-0 left-0 w-2 h-full bg-gradient-to-b from-purple-500 to-pink-500" data-id="element-340" />
            <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-341">
              <CheckCircle2 className="w-6 h-6 text-green-400" data-id="element-342" />
              Lo que logras con nosotros:
            </h3>
            <ul className="space-y-4" data-id="element-343">
              <li className="flex items-start gap-3 text-gray-300" data-id="element-344">
                <span className="text-green-400 mt-1" data-id="element-345">✓</span>
                <span data-id="element-346">
                  Un menú digital profesional que muestra tu menú, ambiente y
                  genera reservaciones al instante.
                </span>
              </li>
              <li className="flex items-start gap-3 text-gray-300" data-id="element-347">
                <span className="text-green-400 mt-1" data-id="element-348">✓</span>
                <span data-id="element-349">
                  Solo te escriben clientes informados y listos para reservar o
                  pedir.
                </span>
              </li>
              <li className="flex items-start gap-3 text-gray-300" data-id="element-350">
                <span className="text-green-400 mt-1" data-id="element-351">✓</span>
                <span data-id="element-352">
                  Botón directo a tu WhatsApp para reservaciones sin
                  complicaciones.
                </span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}